<template>
  <div class="mt-3">
    <top-table
      :columns="columns"
      :sortable="sortable"
      :url="url"
      ref="table"
      :overlap="false"
      :onLoadData="onLoadData"
      :requestFunction="requestFunc"
    >
      <template slot="supplier" slot-scope="props">
        <span v-if="props.row?.allEQPSuppliers"> All suppliers marked as EQP </span>
        <div v-else>
          {{ props.row?.supplier ? props.row?.supplier?.name : props.row?.name || '' }}
          <span
            class="badge badge-info ml-2"
            title="Available Products"
            v-b-tooltip.hover
            v-if="props.row?.productsCount"
          >
            {{ props.row?.productsCount }}
          </span>
          <span class="badge badge-info ml-2" v-else>No Available Products</span>
        </div>
      </template>
      <template slot="categories" slot-scope="props">{{
        props.row?.categories?.map((e) => e.name).join(', ')
      }}</template>
      <template slot="facets" slot-scope="props">{{ props.row?.facets?.map((e) => e.name).join(', ') }}</template>
      <template slot="actions" slot-scope="props">
        <div class="d-flex align-items-center">
          <FormModal
            :item="props.row"
            :hideRule="true"
            @change="onChange"
            :key="props.row.updatedAt"
            v-if="!props.row?.isNotIncluded"
          />
          <delete-button
            v-if="!props.row?.isNotIncluded"
            :title="props.row?.supplier?.name ? props.row?.supplier?.name : props.row?.name || '-'"
            :record="props.row"
            :remove="() => remove(props)"
          />
        </div>
      </template>
      <template slot="customAfterFilter" slot-scope="props">
        <div class="ml-2 mt-4">
          <FormModal
            :hideRule="true"
            :hasSupplierExclusions="hasSupplierExclusions"
            :item="{ categories: [], facets: [], supplier: null, mode: isExcludeMode ? 1 : 2 }"
            @change="onChange"
          />
        </div>
      </template>
    </top-table>
  </div>
</template>

<script>
export default {
  name: 'SupplierList',
  components: {
    FormModal: () => import('./FormModal.vue')
  },
  props: {
    mode: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      hasSupplierExclusions: false,
      columns: ['supplier', 'categories', 'facets', 'actions'],
      sortable: ['supplier']
    };
  },
  computed: {
    isExcludeMode() {
      return this.mode === 1;
    },
    url() {
      return `/stores/${this.storeId}/exclude-suppliers`;
    },
    storeId() {
      return this.$store.getters['stores/store']._id;
    }
  },
  methods: {
    onLoadData(res) {
      this.hasSupplierExclusions = res.data?.length && res.data[0].isNotIncluded;
    },
    requestFunc(p) {
      p.mode = [{ val: this.mode }];
      p.storeId = this.storeId;
      if (!this.isExcludeMode) {
        p.onlyUserDistributor = true;
        p.withProductsCounts = true;
        p.filter = { status: [{ val: 3 }] };
      } else {
        p.forExcludedSuppliers = true;
      }
    },
    async remove(props) {
      await this.$http.delete(`${this.url}/-1/conditions/${props.row._id}`);
      this.onChange();
    },
    onChange() {
      this.$emit('change');
      this.$refs.table.refresh();
    }
  }
};
</script>
